export const isAex =
  process.env.VUE_APP_BRAND === "aex" ||
  /^(?:www\.)?aex\.cx$/i.test(window.location.hostname);

export const walletPath = isAex ? "/wallet" : "/";

export const aexLogo =
  '<img src="/aex/logo.png" alt="AEX" style="width:100%;height:100%;object-fit:contain" />';

export const brandDocument = (url: string): string =>
  !isAex
    ? url
    : url === "/files/licenziya.pdf"
    ? "/aex/license.jpg"
    : url === "/files/politika-aml.docx"
    ? "/aex/files/politika-aml.pdf"
    : url.replace(/^\/files\//, "/aex/files/");

export const brandIcons = <T extends Record<string, string>>(icons: T): T =>
  isAex ? { ...icons, logo: aexLogo, logoSmall: aexLogo } : icons;

export const brandMessages = <T extends Record<string, unknown>>(
  messages: T
): T =>
  isAex
    ? (Object.fromEntries(
        Object.entries(messages).map(([key, value]) => [
          key,
          typeof value === "string"
            ? value
                .replace(/ОсОО\s*«МЕКС»/g, "ОсОО «Асикс»")
                .replace(/MEX LLC/g, "ОсОО «Асикс»")
                .replace(/LLC\s*[«“"]MEX[»”"]/g, "ОсОО «Асикс»")
                .replace(/MEX/g, "AEX")
            : value && typeof value === "object"
            ? brandMessages(value as Record<string, unknown>)
            : value,
        ])
      ) as T)
    : messages;
